// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bWvm","right":"styles_right__2kqkb"};